import { Button, Form, Pagination } from 'react-bootstrap';
import '../../styles/Pagination.css';
import { useEffect, useState } from "react";
import { FaSearch } from 'react-icons/fa'; // FaSearch için import

export default function MyPagination({ total, current, onChangePage }) {
    const [isMobile, setIsMobile] = useState(false);
    const [inputPage, setInputPage] = useState(''); // Sayfa numarası için state

    // Ekran boyutunu dinamik olarak kontrol et
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768); // Ekran genişliği 768px'den küçükse mobil kabul et
        };

        handleResize(); // Başlangıçta durumu kontrol et
        window.addEventListener('resize', handleResize); // Ekran boyutu değiştikçe kontrol et

        return () => {
            window.removeEventListener('resize', handleResize); // Temizleme işlemi
        };
    }, []);

    useEffect(() => {
        setInputPage(current.toString()); // Sayfa değiştiğinde input kutusundaki sayfa numarasını günceller
    }, [current]);

    const items = [];

    // Geri okunu ekle
    items.push(
        <Pagination.Prev
            key={`prev-${current}`}  // Benzersiz key
            onClick={() => onChangePage(current - 1)}
            disabled={current === 1} // İlk sayfadaysa devre dışı bırak
        >
            &laquo;
        </Pagination.Prev>
    );

    if (isMobile) {
        // **MOBİL**: Sadece ilk sayfa, mevcut sayfa ve son sayfa gösterimi
        items.push(
            <Pagination.Item
                key={`page-1`} // Benzersiz key
                active={current === 1}
                onClick={() => onChangePage(1)}
                className={current === 1 ? "active-custom" : ""}
            >
                1
            </Pagination.Item>
        );

        if (current > 2) {
            items.push(<Pagination.Ellipsis key={`ellipsis-start-${current}`} disabled />);
        }

        if (current !== 1 && current !== total) {
            items.push(
                <Pagination.Item
                    key={`page-${current}`}  // Benzersiz key
                    active
                    onClick={() => onChangePage(current)}
                    className="active-custom"
                >
                    {current}
                </Pagination.Item>
            );
        }

        if (current < total - 1) {
            items.push(<Pagination.Ellipsis key={`ellipsis-end-${current}`} disabled />);
        }

        if (total > 1) {
            items.push(
                <Pagination.Item
                    key={`page-${total}`}  // Benzersiz key
                    active={current === total}
                    onClick={() => onChangePage(total)}
                    className={current === total ? "active-custom" : ""}
                >
                    {total}
                </Pagination.Item>
            );
        }
    } else {
        // **WEB**: 2 sola, 2 sağa gösterim
        const startPage = Math.max(1, current - 2);
        const endPage = Math.min(total, current + 2);

        // Başlangıç sayfasını göster
        items.push(
            <Pagination.Item
                key={`page-1`}  // Benzersiz key
                active={current === 1}
                onClick={() => onChangePage(1)}
                className={current === 1 ? "active-custom" : ""}
            >
                1
            </Pagination.Item>
        );

        if (startPage > 2) {
            items.push(<Pagination.Ellipsis key={`ellipsis-start-${startPage}`} disabled />);
        }

        for (let page = startPage; page <= endPage; page++) {
            if (page !== 1 && page !== total) {
                items.push(
                    <Pagination.Item
                        key={`page-${page}`}  // Benzersiz key
                        active={page === current}
                        onClick={() => onChangePage(page)}
                        className={page === current ? "active-custom" : ""}
                    >
                        {page}
                    </Pagination.Item>
                );
            }
        }

        if (endPage < total - 1) {
            items.push(<Pagination.Ellipsis key={`ellipsis-end-${endPage}`} disabled />);
        }

        // Son sayfayı göster
        if (total > 1) {
            items.push(
                <Pagination.Item
                    key={`page-${total}`}  // Benzersiz key
                    active={current === total}
                    onClick={() => onChangePage(total)}
                    className={current === total ? "active-custom" : ""}
                >
                    {total}
                </Pagination.Item>
            );
        }
    }

    // İleri okunu ekle
    items.push(
        <Pagination.Next
            key={`next-${current}`}  // Benzersiz key
            onClick={() => onChangePage(current + 1)}
            disabled={current === total} // Son sayfadaysa devre dışı bırak
        >
            &raquo;
        </Pagination.Next>
    );


    if (!isMobile) {
        items.push(
            <Form inline="true" key={`jump-to-page-${current}`} style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                <Form.Control
                    type="number"
                    value={inputPage}
                    onChange={(e) => setInputPage(e.target.value)}
                    placeholder="Sayfa No"
                    style={{ width: '70px', marginRight: '5px' }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();  // Sayfanın yeniden yüklenmesini engeller
                            const pageNum = parseInt(inputPage, 10); // Tüm girdiği sayıyı alır
                            if (!isNaN(pageNum) && pageNum > 0 && pageNum <= total) {
                                onChangePage(pageNum);  // Girilen sayfaya yönlendirir
                            }
                        }
                    }}
                />
            </Form>
        );

        items.push(
            <Button
                key={`search-button-${current}`}  // Benzersiz key ekliyoruz
                className={"btn-black mt-0 w-5 search-btn"}
                onClick={() => {
                    const pageNum = parseInt(inputPage, 10);
                    if (pageNum > 0 && pageNum <= total) {
                        onChangePage(pageNum);
                    }
                }}
            >
                <FaSearch />
            </Button>
        );
    }

    return (
        <>
            {isMobile && (
                <div className={`search-container ${isMobile ? 'mobile' : ''}`} key={`search-container-${current}`}>
                    <Form inline="true">
                        <Form.Control
                            type="number"
                            value={inputPage}
                            onChange={(e) => setInputPage(e.target.value)}
                            placeholder="Sayfa No"
                            style={{ width: '70px', marginRight: '5px' }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const pageNum = parseInt(inputPage, 10);
                                    if (!isNaN(pageNum) && pageNum > 0 && pageNum <= total) {
                                        onChangePage(pageNum);
                                    }
                                }
                            }}
                        />
                    </Form>
                    <Button
                        className="btn-black mt-0 w-5"
                        onClick={() => {
                            const pageNum = parseInt(inputPage, 10);
                            if (pageNum > 0 && pageNum <= total) {
                                onChangePage(pageNum);
                            }
                        }}
                    >
                        <FaSearch />
                    </Button>
                </div>
            )}

            {/* Pagination öğelerini burada render ediyoruz */}
            <Pagination>{items}</Pagination>
        </>
    );
}